"use client";
import { useState } from "react";
import {
  Database,
  Home,
  Layers,
  Plus,
  TableProperties,
  Menu,
  X,
  LayoutDashboard,
  LayoutList,
  Router,
  Map,
  Hammer,
  PackageSearch,
  ListStart,
} from "lucide-react";
import { FaLessThan } from "react-icons/fa";
// import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import styles from "../Styles/ui/Sidebar.module.css";
import DashboardLogo from "../../../assets/inventory_icons/dashboard.png";
import AddConnectionLogo from "../../../assets/inventory_icons/add.png";
import SchemaExplorerLogo from "../../../assets/inventory_icons/schema.png";
import InventoryBuilderLogo from "../../../assets/inventory_icons/inventory.png";
import InventoryManagementLogo from "../../../assets/inventory_icons/list.png";
import HyphenViewLogo from "../../../assets/brand_icons/Hyphen.png";
import InventoryAppLogo from "../../../assets/brand_icons/inventory_app_day.png";

export function AppSidebar({ isOpen, toggleSidebar, isParent = false }) {
  return (
    <div className={styles.sideBarSuperContainer}>
      <div
        className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}
      >
        <h1 className={styles.sidebarTitle}>Inventory Management</h1>
        <div className={styles.menu}>
          <div className={styles.menuItem}>
            <NavLink
              to="/inventory_dashboard"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <LayoutList className={styles.menuIcon} />
              <span>Inventory Dashboard</span>
            </NavLink>
          </div>
          <div className={styles.menuItem}>
            <NavLink
              to="/add_connection"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <Router className={styles.menuIcon} />
              <span>New Connection</span>
            </NavLink>
          </div>
          <div className={styles.menuItem}>
            <NavLink
              to="/schema_explorer"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <Map className={styles.menuIcon} />
              <span>Schema Explorer</span>
            </NavLink>
          </div>
          <div className={styles.menuItem}>
            <NavLink
              to="/inventory_builder"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <Hammer className={styles.menuIcon} />
              <span>Inventory Builder</span>
            </NavLink>
          </div>
          <div className={styles.menuItem}>
            <NavLink
              to="/inventory_management"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <PackageSearch className={styles.menuIcon} />
              <span>Manage Inventories</span>
            </NavLink>
          </div>
          <div className={styles.menuItem}>
            <NavLink
              to="/list_of_favorites"
              className={({ isActive }) =>
                `${styles.menuLink} ${isActive ? styles.active : ""}`
              }
            >
              <ListStart className={styles.menuIcon} />
              <span>List Of Favorites</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}
